import { Component, inject } from "@angular/core";
import { MatDialogRef, MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";

import { ConfirmDialog } from '@app/shared/dialog/confirm-dialog/confirm-dialog.model';

@Component({
    selector: "inspekt-confirm-dialog",
    templateUrl: "./confirm-dialog.component.html",
    styleUrls: ["./confirm-dialog.component.scss"],
    imports: [MatDialogModule, MatButtonModule, TranslateModule],
})
export class ConfirmDialogComponent {
    dialogRef = inject<MatDialogRef<ConfirmDialogComponent, boolean>>(MatDialogRef);

    public dialog: ConfirmDialog;

    public ok(): void {
        this.dialog.clickedOk = true;
        this.dialogRef.close(true);
    }

    public cancel() {
        this.dialog.clickedOk = false;
        this.dialogRef.close(false);
    }
}
